import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const Image = styled.img`
  display: ${props => (props.inline ? 'inline-block' : 'block')};
  height: auto;
  max-width: 100%;
`;

export default props => <Image {...props} />;



// WEBPACK FOOTER //
// ./src/components/ResponsiveImg.js